import { styled } from "@mui/material";

export const StyledSpecificDatePickersLayout = styled("div")`
  border-radius: ${(props) => props.theme.wsc.radius.m};
  border: 1px solid ${(props) => props.theme.wsc.palette.neutral[700]};
  background-color: ${(props) => props.theme.wsc.palette.neutral[800]};
  padding-top: ${(props) => props.theme.wsc.spacing[3]};

  .MuiPickersLayout-root {
    border: none;
  }
`;
